import { DiscussLink } from 'contentlayer/generated'
import Link from './Link'
import { FunctionComponent } from 'react'
import HackerNewsLogo from './icons/social-icons/hackernews.svg'
import TwitterLogo from './icons/social-icons/twitter.svg'
import RedditLogo from './icons/social-icons/reddit.svg'
import { trackEvent } from 'lib/utils/analytics'

interface IDiscussOnBlogProps {
  discuss: DiscussLink[]
}

const getDiscussButtonMetadata = (discussItem: DiscussLink) => {
  if (discussItem.id === 'hackernews') {
    return {
      className: 'bg-[#ff4000]',
      text: 'Discuss on HackerNews',
      Logo: HackerNewsLogo,
    }
  }

  if (discussItem.id === 'reddit') {
    return {
      className: 'bg-[#ff4500]',
      text: 'Discuss on Reddit',
      Logo: RedditLogo,
    }
  }

  if (discussItem.id === 'twitter') {
    return {
      className: 'bg-[#1da1f2]',
      text: 'Discuss on Twitter',
      Logo: TwitterLogo,
    }
  }
}

const DiscussOnBlogButtons: FunctionComponent<IDiscussOnBlogProps> = ({ discuss }): JSX.Element => {
  if (!discuss || discuss.length === 0) return null

  return (
    <div className="flex flex-row gap-4 flex-wrap">
      {discuss.map((discussItem) => {
        const metadata = getDiscussButtonMetadata(discussItem)

        return (
          <Link
            key={discussItem.id + discussItem.url}
            href={discussItem.url}
            showExternalIcon={false}
            showExternalPreview={false}
            onClick={() =>
              trackEvent({
                name: 'DiscussOnBlogButton',
                data: { id: discussItem.id, url: discussItem.url },
              })
            }
            className={`p-2 rounded-sm flex gap-2 font-semibold ${metadata.className}`}
          >
            <span className="h-6 w-6 inline-block !text-white">
              <metadata.Logo />
            </span>
            {metadata.text}
          </Link>
        )
      })}
    </div>
  )
}

export default DiscussOnBlogButtons
